import {Box, BoxProps, Chip, Typography} from "@mui/material"
import {FC} from "react"
import {makeStyles} from "tss-react/mui";
import {Check} from "@mui/icons-material";
import VideoPreviewSlim from "@/app2/pages/TrainingFeedPage/VideoPreviewSlim";
import {palette} from "@/constants";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {IconAdminCourses} from "@/icons/IconAdminCourses";
import {FinishedCourseDto} from "@/app2/shared/data";

interface IProps extends BoxProps {
	course: FinishedCourseDto
}

const useStyles = makeStyles<{complete: boolean; inactive: boolean}>()((theme, {complete, inactive}) => ({
	courseSummaryCard: {
		width:  "100%",
		display: "flex",
		flexDirection: "row",
		gap: "10px",
		textAlign: "left",
		boxSizing: "border-box",
		borderRadius: "16px",
		padding: "10px",
		background: palette.grey05,
		backgroundClip:  "padding-box",
		flexGrow: 2,
		position: "relative",
		border:
			"1px solid " +
			(inactive ? palette.grey08 : complete ? theme.palette.primary.main : palette.grey05),
		opacity: inactive ? 0.85 : 1,

		"[class*='previewImageSvg']": {
			width: "32px!important",
			height: "32px",
			svg: {
				width: "44px",
				height: "44px",
				transform: "translate(-6px, -6px)",
				marginRight: "auto",
				marginLeft: "auto"

			}
		}
	},
	videoImage: {},
	titleRow: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		gap: "8px",
		flexWrap: "wrap"
	},
	title: {
		fontWeight: 600,
		fontSize: "15px",
		overflow: "hidden",
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 4,
		flex: "1 1 auto",
		minWidth: 0
	},
	inactiveChip: {
		flexShrink: 0,
		height: "22px",
		"& .MuiChip-label": {
			paddingLeft: "8px",
			paddingRight: "8px",
			fontSize: "11px",
			color: 'white'
		}
	},
	blankPreview: {
		borderRadius: "5px",
		overflow: "hidden",
		width: "90px",
		height: "70px",
		backgroundColor: theme.palette.primary.main,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		svg: {
			fill: theme.palette.common.white,
			width: "38px",
			height: "38px"
		}
	},
	blankButton: {
		backgroundColor: "transparent",
		padding: "0px",
		border: "none",
		lineHeight: "1em",
		":hover": {
			backgroundColor: "transparent",
			border: "none"
		}
	},
	completedCheck: {
		opacity: 1,
		position: "absolute",
		width: "20px",
		height: "20px",
		display: "flex",
		justifyContent: "center",
		textAlign: "center",
		flexDirection: "column",
		borderRadius: "100%",
		background: theme.palette.primary.main,
		top: -8,
		right: -8,
		zIndex: 10,
		"& svg": {
			width: "15px",
			height: "15px",
			margin: "auto",
			"& path": {
				fill: theme.palette.common.black
			}
		}
	},
	itemDetailsContainer: {
		border: "none",
		"h3": {
			textDecoration: "none"
		}
	}
}));


export const CourseSummaryCard:FC<IProps> = ({className, course}) => {
	const inactive = course.isActive === false;
	const {classes, cx} = useStyles({complete: true, inactive});
	const {t} = useSSTranslation();
	const thumbnailUrl = course.featuredImage;

	return (
		<Box className={cx(classes.courseSummaryCard, className)}>
			{(true) && <Box className={classes.completedCheck}>
				<Check/>
			</Box>}
			<Box className={classes.blankButton}>
				{(thumbnailUrl)
					? <VideoPreviewSlim disablePlayIcon className={classes.videoImage} videoUrl={thumbnailUrl} />
					: <Box className={classes.blankPreview}>
						<IconAdminCourses />
					</Box>
				}
			</Box>
			<Box>
				<Box className={classes.itemDetailsContainer}>
					<Box className={classes.titleRow}>
						<Typography className={classes.title} variant="h4">{course.title}</Typography>
						{inactive && (
							<Chip
								className={classes.inactiveChip}
								size="small"
								label={t(
									"page_progress_finished_course_unavailable",
									"Unavailable"
								)}
								variant="outlined"
								color="primary"
							/>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	)
}